module.exports = __webpack_public_path__ + "static/media/033_g7_2Desktop V2 logged in.74e5a27d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/033_g7_2Desktop V2 logged in.png
// module id = 450
// module chunks = 0